{
  "issuer": "https://idp-dev.unicloudgroup.com.vn/realms/realm_unihrm",
  "clientId": "web_uni_hrm",
  "webId": "6f1b0fa4-02dd-4afc-8113-c2a4cfdc0342",
  "redirectUri": null,
  "logoutUrl": null,
  "responseType": "id_token token",
  "scope": "openid profile api_sre api_home_service api_core_bigtec api_hrm_bigtec api_uni_config",
  "requireHttps": false,
  "showDebugInformation": true,
  "disableAtHashCheck": true,
  "apiServer": "https://dev.api.unicloudgroup.com.vn",
  "apShomeServer": "https://dev.api.apiresident.unicloudgroup.com.vn",
  "apiCoreServer": "https://dev.api.core.unicloudgroup.com.vn",
  "apiHrmConfig": "https://dev.api.hrmconfig.unicloudgroup.com.vn",
  "apiHrmServer": "https://dev.api.hrm.unicloudgroup.com.vn",
  "pathUpload": "bizzone-web",
  "socketServer": "wss://localhost:6999",
  "apSocketChatServer": "https://chat.sunshineapp.co/api",
  "cloudFunction": "https://asia-northeast1-sunshine-app-production.cloudfunctions.net",
  "firebase": null
}